const mutations = {
  uploaded (state, { error, data, uploaded }) {
    state.storage.error = error || null
    state.storage.data = data || null
    state.storage.uploaded = uploaded
  },

  uploading (state, status) {
    state.storage.uploading = status
  }
}

export default mutations
